module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-content-block', [(_vm.current) ? _c('subAttribute', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "attributes": _vm.current.attributes
    },
    on: {
      "update": _vm.updateAttribute
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21010215","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/attributes.vue
// module id = 533
// module chunks = 1